import React, { useEffect, useState, useContext } from 'react';
import { Link, Loading, UserContext } from 'school-space-client/components';
import { useLocation, Redirect } from 'react-router-dom';
import * as qs from 'query-string';
import { confirmPaymentSessionId, addDeposit } from 'school-space-client/api';

const PaymentSuccess = () => {
    const user = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const parsed = qs.parse(location.search);

    useEffect(() => {
        confirmPaymentSessionId(parsed.customerId, parsed.session_id)
            .then(data => {
                setLoading(false);
                const payload = {
                    amount: JSON.stringify(data.amount_total),
                    paymentDetails: {
                        id: data.id,
                        payment_intent: data.payment_intent,
                        payment_status: data.payment_status,
                        payment_method_types: data.payment_method_types
                    },
                    refundDetails: {}
                };
                addDeposit(parsed.customerId, payload)
                    .then(depositData => {
                        console.log(depositData);
                        const customerDeposit = {
                            id: data.id,
                            customerId: parsed.customerId,
                            amount: data.amount_total,
                            refundStatus: false
                        };
                        user.setCustomerDeposits(customerDeposit);
                    })
                    .catch(error => alert(JSON.stringify(error)));
            })
            .catch(error => {
                setLoading(false);
                console.log(error);
                return <Redirect to="/payment-failed" />;
            });
    }, [parsed.customerId, parsed.session_id, user]);

    return (
        <div className="row">
            <div className="col-md-12 mx-auto mt-5">
                <div className="payment">
                    {loading ? (
                        <Loading fullHeight />
                    ) : (
                        <div className="content">
                            <h1>Payment Success !</h1>
                            <p />
                            <Link url="/">Go to Home</Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
